import { IWatchlist } from "../models";
import {
    GET_WATCHLIST,
    ADD_TO_WATCHLIST,
	REMOVE_FROM_WATCHLIST,
	Actions
} from "../actions";
import { appendToLoading, removeFromLoading } from "../utils";

export function watchlistReducer(state: IWatchlist[] = [], action:Actions) {
	switch (action.type) {
		case GET_WATCHLIST:
			return [].concat(action.payload);
		case ADD_TO_WATCHLIST:
			return [].concat(action.payload);
		case REMOVE_FROM_WATCHLIST:
			return [].concat(action.payload);
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/client/reducers/watchlist.ts